/** Fallback estático da LP/cadastro quando GET /public/billing/plans falha. Fonte da verdade: billing_plan_catalog (admin). */

export const GOLD_MONTHLY_BRL = 197;

export const PLAN_COPY = {
  trial: {
    name: 'Teste completo — 7 dias',
    subtitle: 'Loja na web, pedidos e cadastro de clientes num só lugar',
    priceLabel: 'Grátis por 7 dias',
    bullets: [
      'Loja com vitrine, carrinho e fechamento do pedido',
      'Painel com pedidos ao vivo, clientes e produtos',
      'Aparência da loja e da marca do jeito que você quiser',
      'Não pedimos cartão para começar o período de teste',
    ],
    caveat: 'A ligação automática com o sistema da empresa (ERP) fica no Plano Ouro.',
  },
  gold: {
    name: 'Ouro — para quem já opera com sistema na empresa',
    subtitle: 'Tudo do teste, mais a ponte com o seu estoque e financeiro',
    featured: true,
    priceLabel: `R$ ${GOLD_MONTHLY_BRL}`,
    cadence: ' por mês · pagamento por link (cartão online em breve)',
    bullets: [
      'Tudo que o teste oferece, liberado o tempo todo',
      'Seu sistema pode consultar produtos, clientes e pedidos direto na plataforma',
      'Chave de acesso da empresa: você gera e renova quando quiser',
      'Novidades para integração no radar (avisos automáticos, etc.)',
    ],
  },
};
